export const stringsKey = "VariablesList";
export const englishStrings = {
	variablesListErrorMessage: "Failed to load variables list!",
	selectPlaceholder: "Select a country",
};
